export default "/kiban/_next/static/images/22_8L_1-6-1_withoutBH-84d54b3d6fba7f1f3ffcda1d36d0f955.png";